var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":(event) => _vm.$emit('onChange', event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }